import React, { useState } from "react"
import { Link as PageLink } from "gatsby"
import { LinkPropsType, ExternalLinkPropsType } from "./types"

const Icon: any = React.lazy(() => import("../icon"))

const ExternalLink = ({ animate = true, ...props }: ExternalLinkPropsType) => {
  const [scale, setScale] = useState(1)

  const setState = (n: number) => {
    if (animate) {
      setScale(n)
    }
  }

  return (
    <a
      className={props.className}
      onMouseDown={() => setState(0.95)}
      onMouseUp={() => setState(1)}
      onTouchStart={() => setState(0.95)}
      onTouchEnd={() => setState(1)}
      style={{ transform: `scale(${scale})`, transition: "transform 0.2s" }}
      title={props.title}
      href={props.to}
      target={props.target}
      onClick={props.onClick}
    >
      {props.children}
    </a>
  )
}

const Link = (props: LinkPropsType) => {
  const LinkTag = props.page_slug ? PageLink : ExternalLink
  let slug = (props.page_slug ? props.page_slug : props.external_link) as string
  if (props.anchor) {
    slug = `${slug}#${props.anchor}`
  }
  return (
    <LinkTag
      className={props.className}
      to={slug}
      title={props.title}
      target={props.target}
      onClick={props.onClick}
      animate={props.animate}
    >
      {!!props.icon && <Icon icon={props.icon} />}
      {props.children ? props.children : props.text}
    </LinkTag>
  )
}

export default Link
